import { EmptyStateExplainerCard } from '../../components/EmptyStates'

import type { JSX } from 'react'

/**
 * Explainer shown inside the listening empty state for a realtime-sync channel
 * (webhook/firehose) that has no comments. Unlike polling channels, realtime
 * channels aren't backfilled, so history from before connecting never appears —
 * this sets that expectation. Rendered only for a single realtime channel; it
 * persists while the channel has no comments (no first-backfill signal exists).
 */
export function NoRealtimeHistoryCard(): JSX.Element {
  return (
    <EmptyStateExplainerCard
      heading="Can't see all your past comments? Don't worry!"
      body="We show new comments as they come in. We don't import comments from before you connected this channel."
    />
  )
}
